'use client'

import dynamic from 'next/dynamic'

const SplashCursor = dynamic(() => import('@/components/SplashCursor'), {
    ssr: false,
})

const CookieConsent = dynamic(() => import('@/components/layout/CookieConsent').then(mod => mod.CookieConsent), {
    ssr: false,
})

export default function DynamicEffects() {
    return (
        <>
            <SplashCursor />
            <CookieConsent />
        </>
    )
}
